import React, { useState } from "react";
import {
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
} from "firebase/auth";
import { getDoc, doc } from "firebase/firestore";
import { auth, db } from "../firebase";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import "./Login.css";
import googleIcon from "../assets/google-icon.png";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import logo from "../assets/main-logo.png";
import mlogo from "../assets/mobile-logo.png";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      enqueueSnackbar("Please fill in all fields.", { variant: "warning" });
      return;
    }

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      if (user.emailVerified) {
        setIsAnimating(true);
        setTimeout(() => {
          enqueueSnackbar(`Welcome!`, { variant: "success" });
          navigate("/portal/home");
        }, 900); // time matches CSS transition
      } else {
        enqueueSnackbar("Please verify your email before logging in.", { variant: "warning" });
        await auth.signOut();
      }
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
    }
  };

  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);

      if (!result.user) {
        enqueueSnackbar("Google login failed. Please try again.", { variant: "error" });
        return;
      }

      const user = result.user;
      const userRef = doc(db, "users", user.uid);
      const docSnap = await getDoc(userRef);

      if (docSnap.exists()) {
        setIsAnimating(true);
        setTimeout(() => {
          enqueueSnackbar(`Welcome, ${user.displayName}!`, { variant: "success" });
          navigate("/portal/home");
        }, 900);
      } else {
        await auth.signOut();
        enqueueSnackbar("Unauthorized access. Please contact admin.", { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
    }
  };

  return (
    <div className={`login-page ${isAnimating ? "slide-out-left-blur" : ""}`}>
      <div className="login-left">
        <div className="left-data">
          <img src={mlogo} alt="Logo" className="mlogin-logo" />
          <h1 className="tagline">Transform Your Data Into Impactful Stories</h1>
        </div>
      </div>
      <div className="login-right">
        <div className="login-card">
          <div className="welcome-container">
            <h2 className="hello-text">Welcome to</h2>
            <img src={logo} alt="Logo" className="login-logo" />
            <p className="subtitle">Please log in to access your account</p>
          </div>
          <form onSubmit={handleLogin} className="login-form">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{ backgroundColor: "rgba(255,255,255,0.5)" }}
            />
            <div className="password-input-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ backgroundColor: "rgba(255,255,255,0.5)" }}
              />
              <span
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </span>
            </div>
            <div className="forgot-password">
              <span onClick={() => navigate("/reset-password")}>Forgot Password?</span>
            </div>

            <button type="submit" className="login-button">Continue</button>

            <div className="or-separator">
              <span>OR</span>
            </div>

            <button type="button" className="google-signin-button" onClick={handleGoogleLogin}>
              <img src={googleIcon} alt="Google" className="google-icon" />
              Login with Google
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
